export enum Sorting {
    Frequency = 'FREQUENCY',
    Alphabetically = 'ALPHABETICALLY',
    DateSaved = 'DATE_SAVED',
    DueToReview = 'DUE_TO_REVIEW',
}